// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__R05de","disabled":"FileBtn_disabled__3TUZE","warn":"FileBtn_warn__2pIai","fade":"FileBtn_fade__1EyUb"};